import React, { useEffect, useState } from 'react';
import { bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm, FormSpy } from 'react-final-form';
import { intlShape, injectIntl, FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import config from '../../config';
import { LINE_ITEM_NIGHT, LINE_ITEM_DAY, propTypes } from '../../util/types';
import * as validators from '../../util/validators';
import { convertUnitToSubUnit, formatMoney, unitDivisor } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
  Button,
  Form,
  FieldCurrencyInput,
  FieldCheckbox,
  RangeSlider,
  InlineTextButton,
} from '../../components';
import css from './EditListingPricingForm.module.css';
import { ReactComponent as InfoIcon } from '../../assets/svg/infoIcon.svg';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { withRouter } from 'react-router-dom';

const { Money } = sdkTypes;
const textfield = 'textfield';
const errorTextField = 'errorTextField';
const min_Cnesst_price = 16;

export const EditListingPricingFormComponent = props => (
  <FinalForm
    {...props}
    render={formRenderProps => {
      // console.log(20, props);
      const {
        className,
        disabled,
        ready,
        handleSubmit,
        intl,
        invalid,
        pristine,
        saveActionMsg,
        updated,
        updateInProgress,
        fetchErrors,
        form,
        errors,
        values,
        initialValues,
        commissionRate,
        history,
      } = formRenderProps;
      // console.log(454, initialValues);
      const unitType = config.bookingUnitType;
      const isNightly = unitType === LINE_ITEM_NIGHT;
      const isDaily = unitType === LINE_ITEM_DAY;

      const [isPriceDisabled, setIsPriceDisabled] = useState(true);

      const [percentValue, setPercentValue] = useState(0);

      const [cnesstRule, setCnesstRule] = useState(false);

      const classes = classNames(css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;
      const submitDisabled =
        invalid || disabled || submitInProgress || values.cnesstRule?.[0] !== 'Yes' || pristine;

      const { updateListingError, showListingsError } = fetchErrors || {};

      useEffect(() => {}, [percentValue, values]);

      const handleSliderChange = e => {
        const value = e.currentTarget.value;
        console.log(value, 999);
        setPercentValue(value);
        form.change('percentageValue', value);
        const newPrice =
          initialValues?.basePrice?.amount + (initialValues?.basePrice?.amount * value) / 100;
        // const newClientPriceVal = Math.round(newPrice + (newPrice * commissionRate) / 100);
        const newClientPriceVal = parseInt(newPrice + (newPrice * commissionRate) / 100);

        // console.log(41, newClientPriceVal);

        form.change('price', new Money(newPrice, config.currency));
        form.change('clientPrice', new Money(newClientPriceVal, config.currency));
      };

      const handlePriceChange = (price, clientPrice) => {
        setPercentValue(price?.amount);

        const newClientPriceVal = price?.amount
          ? parseInt(price.amount + (price.amount * commissionRate) / 100)
          : 0;

        if (clientPrice?.amount !== newClientPriceVal) {
          // form.change('price', price);

          form.change('clientPrice', new Money(newClientPriceVal, config.currency));
        }
      };
      const handleCnesstRule = value => {
        if (value[0] === 'Yes') setCnesstRule(true);
        else {
          setCnesstRule(false);
        }

        form.change('cnesstRule', value);
        if (value.length > 0) {
          // setIsPriceDisabled(false);
          setIsPriceDisabled(true);
        }
        // else {
        //   setIsPriceDisabled(true);
        // }
      };
      // console.log(525, values);

      const handleWorkersEarn = value => {
        // console.log(49, 'workersearn', value);
        form.change('workersEarnTip', value);
      };

      //cnesstRule text

      const cnesstRuleText = intl.formatMessage({
        id: 'EditListingLocationForm.cnesstRuleLabel1',
      });

      //workersearn text
      const workersearnText = intl.formatMessage({
        id: 'EditListingLocationForm.workersearnLabel',
      });

      const translationKey = isNightly
        ? 'EditListingPricingForm.pricePerNight'
        : isDaily
        ? 'EditListingPricingForm.pricePerDay'
        : 'EditListingPricingForm.pricePerUnit';

      const pricePerUnitMessage = intl.formatMessage({
        id: translationKey,
      });

      const pricePlaceholderMessage = intl.formatMessage({
        id: 'EditListingPricingForm.priceInputPlaceholder',
      });

      const priceRequired = validators.required(
        intl.formatMessage({
          id: 'EditListingPricingForm.priceRequired',
        })
      );
      // const minPrice = new Money(config.listingMinimumPriceSubUnits, config.currency);
      // const minPrice = new Money(
      //   (config.listingMinimumPriceSubUnits = min_Cnesst_price),
      //   config.currency
      // );

      const minPrice = new Money(initialValues?.basePrice?.amount || 0, config.currency);
      const workerPriceLabel = intl.formatMessage({
        id: 'EditListingPricingForm.workerPriceLabel',
      });
      const workerLabelSubHeading = intl.formatMessage({
        id: 'EditListingPricingForm.workerLabelSubHeading',
      });
      const clientPriceLabel = intl.formatMessage({
        id: 'EditListingPricingForm.clientPriceLabel',
      });
      const minPriceRequired = validators.moneySubUnitAmountAtLeast(
        intl.formatMessage(
          {
            id: 'EditListingPricingForm.priceTooLow',
          },
          {
            minPrice: formatMoney(intl, minPrice),
          }
        ),
        // config.listingMinimumPriceSubUnits
        initialValues?.basePrice?.amount
      );

      const priceValidators = initialValues?.basePrice?.amount
        ? validators.composeValidators(priceRequired, minPriceRequired)
        : priceRequired;
      // const priceValidators = config.listingMinimumPriceSubUnits
      //   ? validators.composeValidators(priceRequired, minPriceRequired)
      //   : priceRequired;

      return (
        <Form onSubmit={handleSubmit} className={classes}>
          <FormSpy
            subscription={{ values: true }}
            onChange={({ values }) => {
              const { price, clientPrice } = values;
              // Perform your calculation here and set another field's value

              handlePriceChange(price, clientPrice);
            }}
          />
          <span className={css.tabTitle}>
            <FormattedMessage id="EditListingWizard.tabLabelPricing" />
          </span>

          <div className={css.pricingDiv}>
            <div className={css.priceRow}>
              <div>
                <label>{workerPriceLabel}</label>

                <p>{workerLabelSubHeading}</p>
                {/* {console.log(333, config.currencyConfig)} */}
                {/* {values && values.price && values.price.hasOwnProperty('amount') && ( */}
                <FieldCurrencyInput
                  id="price"
                  name="price"
                  // className={css.priceInput}
                  className={classNames(textfield, css.priceField)}
                  autoFocus
                  // label={pricePerUnitMessage}
                  placeholder={pricePlaceholderMessage}
                  currencyConfig={config.currencyConfig}
                  validate={priceValidators}
                  // disabled={isPriceDisabled}
                  key={percentValue}
                />
                {/* )} */}
              </div>
              <div>
                <label>
                  {clientPriceLabel}{' '}
                  <span id="cnesstRuleTooltip" className={css.tooltipIcon}>
                    <InfoIcon />
                  </span>
                  <ReactTooltip
                    anchorId="cnesstRuleTooltip"
                    place="right"
                    effect="solid"
                    clickable={false}
                    className={css.categoryTooltip}
                    content={<FormattedMessage id="EditListingPricingForm.cnesstRuleTooltipText" />}
                  />
                </label>

                {/* {values && values?.price && values?.price.hasOwnProperty('amount') && ( */}
                <FieldCurrencyInput
                  id="clientPrice"
                  name="clientPrice"
                  // className={css.priceInput}
                  className={classNames(textfield, css.priceField)}
                  autoFocus
                  // label={pricePerUnitMessage}
                  placeholder={pricePlaceholderMessage}
                  currencyConfig={config.currencyConfig}
                  validate={priceValidators}
                  disabled={isPriceDisabled}
                  // key={'clientPrice'}
                  key={percentValue}
                  onChange={value => console.log(value)}
                />
                {/* )} */}
              </div>
            </div>
            {/* <div className={css.slidercontainer}>
              <label className={css.SliderHeading}>
                {' '}
                <FormattedMessage id="EditListingPricingForm.SliderHeading" />
              </label>
              <p>
                {' '}
                <FormattedMessage id="EditListingPricingForm.SliderSubHeading" />
              </p>
              <span className={css.RangeSliderContainer}>
                <input
                  type="range"
                  min={0}
                  max={100}
                  step={1}
                  defaultValue={values?.percentageValue ? values?.percentageValue : percentValue}
                  onChange={handleSliderChange}
                  name="percentageValue"
                  id="color-slider"
                />
                <p className={css.percentValue}>
                  {' '}
                  {values?.percentageValue ? values?.percentageValue : percentValue}%
                </p>
              </span>
            </div> */}
            <FieldCheckbox
              id="cnesstRule"
              name="cnesstRule"
              label={
                <div>
                  {cnesstRuleText}
                  <p>
                    <FormattedMessage id="EditListingLocationForm.cnesstRuleLabel2" />
                  </p>
                </div>
              }
              // value="cnesstRuleYes"
              value={'Yes'}
              onChange={e => handleCnesstRule(e)}
              className={css.cnesstRule}
            />
          </div>
          <br />

          <FieldCheckbox
            id="workersEarnTip"
            name="workersEarnTip"
            label={workersearnText}
            value="Yes"
            onChange={handleWorkersEarn}
            className={css.workersEarnTip}
          />
          {updateListingError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingPricingForm.updateFailed" />
            </p>
          ) : null}
          {showListingsError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingPricingForm.showListingFailed" />
            </p>
          ) : null}
          <div className={css.ButtonContainer}>
            <Button
              className={css.submitButton}
              // type="button"
              inProgress={submitInProgress}
              disabled={submitDisabled}
              ready={submitReady}
            >
              {saveActionMsg}
            </Button>
            <InlineTextButton
              type="button"
              className={css.cancelBtn}
              onClick={() => {
                // form.reset;
                history.replace(
                  createResourceLocatorString('ManageListingsPage', routeConfiguration())
                );
              }}
            >
              <FormattedMessage id="SignupForm.Cancel" />
            </InlineTextButton>
          </div>
        </Form>
      );
    }}
  />
);

EditListingPricingFormComponent.defaultProps = { fetchErrors: null };

EditListingPricingFormComponent.propTypes = {
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
};

export default compose(
  withRouter,
  injectIntl
)(EditListingPricingFormComponent);
